export enum OperatorEnum {
    EQ = "eq",
    NOT_EQ = "neq",
    GT = "gt",
    GTE = "gte",
    LT = "lt",
    LTE = "lte",
    BETWEEN = "between",
    IN_DATE_RANGE = "in_date_range",
    IN = "in",
    IS_NULL = "is_null",
    IS_NOT_NULL = "is_not_null",
    LIKE = "like",
    BELONG = "belong",
    NOT_BELONG = "not_belong",
}
